export const startCase = (str: string) => {
  if (!str || str.length === 0) return '';

  const words = str.split(' ');
  const capitalised = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalised.join(' ');
};

export const has = (obj: object, key: string): boolean => {
  const keyParts = key.split('.');

  return (
    !!obj &&
    (keyParts.length > 1
      ? has(obj[key.split('.')[0] as keyof typeof obj], keyParts.slice(1).join('.'))
      : obj.hasOwnProperty(key))
  );
};

export const sampleSize = <T>(arr: T[], size: number) => {
  const len = arr === null ? 0 : arr.length;
  const collection = [];
  let oldIndex = 0;
  let newIndex = 0;
  let count = 1;
  while (count <= size) {
    newIndex = Math.floor(Math.random() * len);
    if (oldIndex !== newIndex) {
      collection.push(arr[newIndex]);
      oldIndex = newIndex;
      count++;
    } else {
      count++;
    }
  }
  return collection;
};
